(function () {
    'use strict';

    angular
        .module('app')
        .controller('VerifyController', VerifyController);

    VerifyController.$inject = ['authentication', '$state', 'isVerifying', '$modalInstance', 'config'];

    function VerifyController(authentication, $state, isVerifying, $modalInstance, config) {
        var vm = this;

        vm.isVerifying = isVerifying;

        vm.modalTitle = isVerifying ? "Verify Email" : "Request Verification Email";

        vm.onSubmit = onSubmit;

        function onSubmit() {
            if(isVerifying) {
                authentication.verifyAccount(
                    vm.email, vm.token
                ).then($modalInstance.close).catch(function (error) {
                    vm.formError = error;
                });
            }
            else {
                authentication.sendVerificationEmail(vm.email).then($modalInstance.close).catch(function (error) {
                    vm.formError = error;
                });
            }
        }

    }

})();